<template>
  <div class="body">
    <div class="title">
      彩票发放
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ticketWelfare' }"
            ><span class="dsadf"> 彩票发放 </span></el-breadcrumb-item
          >
          <el-breadcrumb-item>彩票发放列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="btnsearch">
      <div class="left">
        共上传彩票 {{ lotteryTicketStatistics.num }} 张，
        被领取 {{ lotteryTicketStatistics.r_num }} 张，
        彩票池剩余 {{ lotteryTicketStatistics.num - lotteryTicketStatistics.r_num }} 张
      </div>
      <div class="right">
        <el-form :inline="true">
          <el-form-item>
            <el-button type="warning" @click="routerGoEdit">新增活动</el-button>
          </el-form-item>
          <el-form-item>
            <div style="display: flex; flex-direction: column">
              <el-upload
                class="upload-demo"
                ref="upload"
                action="https://api.xhht.yundongm.top:8099/service/admin/lotteryTicketImport"
                :auto-upload="true"
                name="file"
                :show-file-list="false"
                accept="xls"
                :before-upload="onBeforeUpload"
                :on-success="onSuccess"
              >
                <el-button type="primary" slot="trigger"> 添加彩票 </el-button>
              </el-upload>
              <el-button type="text" @click="handleDownLoadTicketTemp">
                <i class="el-icon-download el-icon--right"></i>
                <span>模板下载</span>
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <vxe-table
      :data="ticketActivityList"
      border
      stripe
      resizable
      max-height="750"
      class="mytable-scrollbar"
      show-overflow
      keep-source
      align="center"
      :highlight-current-column="true"
    >
      <vxe-table-column field="id" title="ID" min-width="50">
      </vxe-table-column>
      <vxe-table-column field="title" title="活动标题" min-width="100">
      </vxe-table-column>
      <vxe-table-column field="s_time" title="领取时间" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.s_time }}-{{ scope.row.e_time }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="r_time" title="线下兑换截止" min-width="80">
        <template slot-scope="scope">
          {{ scope.row.r_time }}
        </template>
      </vxe-table-column>
      <vxe-table-column field="sort" title="领取票数" min-width="220">
        <template slot-scope="scope">{{
          scope.row.r_num + "/" + scope.row.num
        }}</template>
      </vxe-table-column>
      <vxe-table-column field="sort" title="明细" min-width="220">
        <template slot-scope="scope">
          <el-button type="text" @click="handleDownLoad(scope.row)"
            >下载明细</el-button
          >
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作" width="240" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="routerGoEdit(scope.row)"
            icon="el-icon-edit"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="handleDelete(scope.row)"
            icon="el-icon-delete"
          >
            删除
          </el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div v-if="pageshow">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="cur_page"
        :page-sizes="[100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { MessageBox } from "element-ui";
import {
  getLotteryActivityList,
  getLotteryTicketStatistics,
  deleteLotteryActivity,
} from "@/api/ticketWelfare.js";
import dayjs from "dayjs";
import { isExcelFile } from "@/utils";

export default {
  name: "index",
  data() {
    return {
      dialogVisibleByNotApplroved: false,
      pageshow: true,
      total: null,
      query: {
        page: 1,
        pagesize: 100,
      },
      ticketActivityList: [],
      lotteryTicketStatistics: {},
      cur_page: 1,
    };
  },
  created() {
    this.getLotteryActivityList();
    this.getLotteryTicketStatistics();
  },
  methods: {
    handleDownLoadTicketTemp() {
      const downloadElement = document.createElement("a");
      const href = `https://app.yundongm.cn/statics-web/admin/彩票模板.xls`;
      downloadElement.href = href;
      downloadElement.target = "_blank";
      downloadElement.download = `彩票模板`;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
    },
    handleDownLoad(item) {
      const downloadElement = document.createElement("a");
      const href = `https://api.xhht.yundongm.top:8099/service/admin/lotteryTicketExport?id=${
        item.id
      }&token=${sessionStorage.getItem("token")}`;
      downloadElement.href = href;
      downloadElement.target = "_blank";
      downloadElement.download = `明细${item.s_time}-${item.e_time}`;
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
    },
    onBeforeUpload(file) {
      console.log("_onBeforeUpload", file);
      if (!isExcelFile(file.name)) {
        this.$message({
          message: "文件类型错误! 应为 .xls .xlsx 结尾",
          type: "warning",
          duration: "2000",
        });

        return false;
      }

      // const writeExt = [
      //   "application/vnd.ms-excel",
      //   "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      // ];
      // if (!writeExt.includes(file.type)) {
      //   this.$message({
      //     message: "文件类型错误!文件应为" + writeExt.join(","),
      //     type: "success",
      //     duration: "2000",
      //   });
      //   return false;
      // }
    },
    onSuccess(ev) {
      this.$message({
        message: ev.msg,
        type: "success",
        duration: "2000",
      });

      this.getLotteryTicketStatistics();
    },
    routerGoEdit(item) {
      this.$router.push(`/ticketWelfareEdit?id=${item.id || ""}`);
    },
    handleDelete(item) {
      MessageBox.confirm(`删除当前文件？「${item.title}」`, {
        showConfirmButton: true,
        showCancelButton: true,
      })
        .then((res) => {
          deleteLotteryActivity({ id: item.id })
            .then((resp) => {
              console.log("_delete", resp);
              this.$message({
                message: resp.data.msg,
                type: "warning",
                duration: "2000",
              });
              this.getLotteryActivityList();
            })
            .catch((err) => {
              this.$message({
                message: err.data.msg,
                type: "danger",
                duration: "2000",
              });
            });
        })
        .catch((err) => {
          console.log("_err");
        });
    },

    Discountsearch() {
      this.cur_page = 1;
      this.getLotteryActivityList();
      this.pageshow = false; // 让分页隐藏
      this.$nextTick(() => {
        // 重新渲染分页
        this.pageshow = true;
      });
    },
    getLotteryActivityList() {
      getLotteryActivityList().then((resp) => {
        this.ticketActivityList = resp.data.data.list.map((item) => {
          return {
            ...item,
            s_time: dayjs(new Date(item.s_time * 1000)).format("YYYY/MM/DD"),
            e_time: dayjs(new Date(item.e_time * 1000)).format("YYYY/MM/DD"),
          };
        });
        this.total = resp.data.data.total - 0;
      });
    },

    getLotteryTicketStatistics() {
      getLotteryTicketStatistics().then((resp) => {
        // console.log("_getLotteryTicketStatistics resp", resp);
        this.lotteryTicketStatistics = resp.data.data;
      });
    },

    handleSizeChange(val) {
      this.query.pagesize = val;
      this.handleCurrentChange(this.query.page);
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getLotteryActivityList();
    },
  },
};
</script>

<style scoped lang="less">
.imgs {
  width: 130px;
  height: 70px;
  background: rgba(0, 0, 0, 0);
  border-radius: 2px;
}
.body {
  display: flex;
  flex-direction: column;
  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }
    .dsadf {
      color: #3d9aff;
    }
  }
  .btnsearch {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    .left {
      margin-right: 150px;
    }
    .right {
      margin-top: 27px;
    }
  }
}
</style>
